import { TWhiteLabel } from '../white-label.model';

export const WHITE_LABEL_COLOR_KEYS: (keyof TWhiteLabel)[] = [
  'panelBg',
  'panelAccent',
  'panelFont',
  'panelFontHighlight',
  'panelText',
  'panelTextHover',
  'iconActiveColorPanel',
  'itemBorder',
  'itemBgHover',
  'primary50',
  'primary75',
  'primary100',
  'primary200',
  'primary300',
  'primary400',
  'primary500',
  'primary600',
  'primary700',
  'primary800',
  'primary900',
  'primary950',
];

export function hasCustomColors(data: TWhiteLabel): boolean {
  return WHITE_LABEL_COLOR_KEYS.some((key) => Boolean(data[key]));
}
